import React, { Suspense } from 'react';
import ContentRoutes from './ContentRoutes';


import Loader from "../Loader/Loader";

const Content = () => {
	// const remove = () => {
	// 	document.querySelector(".sidebar-right").classList.remove("sidebar-open");
	// 	document.querySelector("body").classList.remove("main-sidebar-show");
	// 	document.querySelector(".demo_changer").classList.remove("active");
	// 	document.querySelector(".demo_changer").style.right = "-270px";
	// };

	return (
		// <div className="main-container container-fluid" onClick={() => remove()}>
		// 	<div className="inner-body" >
		// 	</div>
		// </div>

		<Suspense fallback={<Loader />}>
			<ContentRoutes />
		</Suspense>

	);
};

export default Content;
